import { render, staticRenderFns } from "./TemplateUpdate.vue?vue&type=template&id=0f000d4e&"
import script from "./TemplateUpdate.vue?vue&type=script&lang=ts&"
export * from "./TemplateUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports